import { DESIGN_SIZE_TYPE_TYPES, FilterSelectionProp } from '@components/Templates/utils/constants';
import { ThemeProjection } from '@lib/sanity/types/common';
import { LabelValue, LabelValueHint } from '@lib/types';
import Container from '@ui/Container/Container';
import Select from '@ui/Select/Select';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';

type FilterProps = {
  selectedItems: FilterSelectionProp;
  onSelectChange: (data: FilterSelectionProp, pageNum?: number) => void;
  db: {
    styles?: LabelValue[];
    colors?: LabelValue[];
    designSizeTypes?: LabelValueHint[];
    categories?: LabelValue[];
    types?: LabelValue[];
  };
  hideTypeFilter?: boolean;
  theme?: ThemeProjection;
};
export default function Filter({ selectedItems, onSelectChange, theme, hideTypeFilter, db }: FilterProps) {
  return (
    <Container theme={theme} paddingType="horizontalOnly">
      <div
        className={cn(
          'pb-8 pt-8 md:pb-4 md:pt-10',
          'col-span-full flex w-full items-center justify-end gap-2 sm:gap-4',
        )}
      >
        {!!db.colors?.length && (
          <Select
            isMultiple
            label="Color"
            setSelectedItems={(items) => {
              onSelectChange({
                ...selectedItems,
                color: db.colors?.filter((x) => items.includes(x.value)).map((x) => x.label),
              });
            }}
            selectedItems={db.colors?.filter((x) => selectedItems.color?.includes(x.label)).map((x) => x.value)}
            items={db.colors}
          />
        )}
        {!!db.styles?.length && (
          <Select
            isMultiple
            label="Style"
            setSelectedItems={(items) => {
              onSelectChange({
                ...selectedItems,
                style: db.styles?.filter((x) => items.includes(x.value)).map((x) => x.label),
              });
            }}
            selectedItems={db.styles?.filter((x) => selectedItems.style?.includes(x.label)).map((x) => x.value)}
            items={db.styles}
          />
        )}
        {!hideTypeFilter && (
          <Select
            isMultiple={false}
            label="Type"
            setSelectedItems={(items) => {
              onSelectChange({
                ...selectedItems,
                type: DESIGN_SIZE_TYPE_TYPES?.filter((x) => items.includes(x.value)).map((x) => x.label),
              });
            }}
            selectedItems={DESIGN_SIZE_TYPE_TYPES?.filter((x) => selectedItems.type?.includes(x.label)).map(
              (x) => x.value,
            )}
            items={DESIGN_SIZE_TYPE_TYPES}
          />
        )}
        {!!db.designSizeTypes?.length && (
          <Select
            isMultiple
            label="Sizes"
            setSelectedItems={(items) => {
              onSelectChange({
                ...selectedItems,
                size: db.designSizeTypes?.filter((x) => items.includes(x.value)).map((x) => x.label),
              });
            }}
            selectedItems={db.designSizeTypes?.filter((x) => selectedItems.size?.includes(x.label)).map((x) => x.value)}
            items={db.designSizeTypes}
          />
        )}
        {!!db.categories?.length && (
          <Select
            isMultiple
            label="Industries"
            setSelectedItems={(items) => {
              onSelectChange({
                ...selectedItems,
                industry: db.categories?.filter((x) => items.includes(x.value)).map((x) => x.label),
              });
            }}
            selectedItems={db.categories?.filter((x) => selectedItems.industry?.includes(x.label)).map((x) => x.value)}
            items={db.categories}
          />
        )}
        <span
          onClick={() =>
            onSelectChange({
              color: [],
              style: [],
              type: [],
              size: [],
              industry: [],
              page: '1',
            })
          }
          className={cn('hidden cursor-pointer select-none rounded-lg py-1 md:block')}
        >
          <Text
            content="Clear all filters"
            variant={TextVariant.SubtitleSM}
            className={cn('w-full px-2 capitalize', 'text-link decoration-link underline-offset-4 hover:underline')}
          />
        </span>
      </div>
    </Container>
  );
}
